import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import React, { useEffect, useState, useCallback } from "react";
import ReactDOM from "react-dom";
import AccountInfo from "./Profile/AccountInfo";
import Catalog from "./Catalog/Catalog";
import Settings from "./settings"
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import Watermarks from "./Profile/Details/Watermarks";
import moment from "moment";
import MyBalance from "./Profile/MyBalance/MyBalance";
import PopupBuyNow from "./Common/LotView/PopupBuyNow";
/*import applicationStore from "./TradeApplication/applicationStore";*/
import ContactForm from "./Shared/ContactForm";
import EventsList from "./Shared/EventsList";
import PromoLotsList from "./Catalog/PromoLotsList";
import NearestLots from "./Catalog/NearestLots";
//import { ApplicationDetails } from "./TradeApplication/components/ApplicationDetails";
//import { ApplicationAcceptance } from "./TradeApplication/components/ApplicationAcceptance";
import ContactPopup from "./Shared/ContactPopup";
import SmallPromoLots from "./Shared/SmallPromoLots";

import StartTariff from "../ReactComponents/Common/BuyTariffs/StartTariffBuy";
import BasicTariff from "../ReactComponents/Common/BuyTariffs/BasicTariffBuy";
import BuisinessTariff from "../ReactComponents/Common/BuyTariffs/BuisinessTariffBuy";

import AgentHelper from "../ReactComponents/CategoryLotsList/AgentHelper/AgentHelper";
import Boutique from "../ReactComponents/MithraRealty/Boutique/Catalog";

import LotPage from "./Common/LotView/LotPage";
import TestComponents from "./index.test"

import PersonalData from "../ReactComponents/Profile/Details/PersonalData";
import BankDetails from "../ReactComponents/Profile/Details/BankDetails";
import TariffsList from "../ReactComponents/Profile/TariffsList/TariffsList";
import Cert from "../ReactComponents/Profile/Cert/Cert";
import MyDeposits from "../ReactComponents/Profile/MyDeposits/MyDeposits";
import { OpenAuctionWithApplications } from "./Views/LotView2/OpenAuctionWithApplications/OpenAuctionWithApplications"
import { OpenAuctionWithApplicationsReadOnly } from "./Views/LotView2/OpenAuctionWithApplications/OpenAuctionWithApplicationsReadOnly"
import { OpenAuction } from "./Views/LotView2/OpenAuction/OpenAuction"
import { OpenAuctionReadOnly } from "./Views/LotView2/OpenAuction/OpenAuctionReadOnly"
import { OpenAuctionWithDeposit } from "./Views/LotView2/OpenAuctionWithDeposit/OpenAuctionWithDeposit"
import { OpenAuctionWithDepositReadOnly } from "./Views/LotView2/OpenAuctionWithDeposit/OpenAuctionWithDepositReadOnly"
import { MyActivityClass } from "./Views/MyActivity/Main/MyActivityClass"

import UploadDocuments from "../ReactComponents/Profile/Documents/UploadDocuments";
import ProfileDocuments from "./Profile/Documents/ProfileDocuments";

import UsefulLinks from "./MithraRealty/UsefulLinks";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
const queryClient = new QueryClient();

import Header from "./MithraRealty/Header";
import Footer from "./MithraRosim/Footer";

import { store } from "./Store/store";

import Store from "./Store";

import AppWrapper from "./AppWrapper";
import NewsList from "./Ui/News/NewsList";


// метод инициализирующий класс AccountInfo
const LoadAccountInfo = async (result) => {
    console.log('загрузим даные об аккаунте');
    const accountInfo = document.getElementById("accountInfo");

    if (accountInfo) {
        console.log("accountInfo найден!!!");
        AccountInfo.Thumbprint = accountInfo.getAttribute('data-thumbprint');
        AccountInfo.Id = Number(accountInfo.getAttribute('data-id'));
        AccountInfo.Fio = accountInfo.getAttribute('data-fio');
        AccountInfo.IsAdminRole = accountInfo.getAttribute('data-isAdminRole');
        AccountInfo.CurrentUserCanSign = Boolean(accountInfo.getAttribute('data-currentUserCanSign'));
        AccountInfo.init(LoadAll);
        console.log('AccountInfo: ', AccountInfo);
    } else {
        console.log("accountInfo не найден");
        LoadAll();
    }
}

// вызовет инициализацию настроек, которые нам могут понадобиться в любом другом компоненте
Settings.Init(LoadAccountInfo);

// метод загружающий все другие комопненты. !!! Внимание он должен быть вызван после получения данных настроект и информации об аккаунте!
const LoadAll = (result) => {

    TestComponents.LoadAll();

    const CategoryLotsList = React.lazy(() => import("./CategoryLotsList/List"));
    const LotsEditor = React.lazy(() => import("./LotsEditor2/LotsEditor"));
    const MainSearch = React.lazy(() => import("./MainSearch/Index"));
    const ProfileDetailsEditor = React.lazy(
        () => import("./Profile/Details/ProfileDetailsEditor"),
    );
    const VacationDetailsEditor = React.lazy(
        () => import("./Profile/Vacation/VacationDetailsEditor"),
    );

    const DeliveryAdressDetailsEditor = React.lazy(
        () => import("./Profile/DeliveryAdress/DeliveryAdressDetailsEditor"),
    );
    const LocationLotDetailsEditor = React.lazy(
        () => import("./Profile/LocationLot/LocationLotDetailsEditor"),
    );
    const BlackListSellersDetailsEditor = React.lazy(
        () => import("./Profile/BlackList/BlackListSellersDetailsEditor"),
    );
    const BlackListBuyersDetailsEditor = React.lazy(
        () => import("./Profile/BlackList/BlackListBuyersDetailsEditor"),
    );
    const StandartDescriptionLotEditor = React.lazy(
        () => import("./Profile/StandertDescriptionLot/StandartDescriptionLotEditor"),
    );
    const BalanceEditor = React.lazy(
        () => import("./Profile/Balance/BalanceEditor"),
    );


    const Appeal = React.lazy(() => import("./Profile/Appeal/Appeal"));

    const Rate = React.lazy(() => import("./Profile/Rate/Rate"));

    const PromotionServices = React.lazy(() => import("./Profile/PromotionServices/PromotionServices"));


    const RatingLimit = React.lazy(() => import("./Profile/RatingLimit/RatingLimit"));


    const OperatinosHistory = React.lazy(() => import("./Profile/OperatinosHistory/OperatinosHistory"));

    const MessageToBuyers = React.lazy(() => import("./Profile/MessageToBuyers/MessageToBuyers"));

    const Notifications = React.lazy(
        () => import("./Profile/Notifications/Components/Notifications"),
    );

    const LotDocument = React.lazy(
        () => import("./Common/Document/LotDocument"),
    );

    const LotWinnerProtocol = React.lazy(
        () => import("./Common/Document/LotWinnerProtocol")
    );

    const DocumentsList = React.lazy(() => import("./Common/Document/List"));
    const MyActivity2 = React.lazy(() => import("./MyActivity/MyActivity2"));

    const ToggleLotIsFavorite = React.lazy(
        () => import("./Common/ToggleLotIsFavorite/ToggleLotIsFavorite"),
    );

    const ChatBoxButton = React.lazy(() => import("./Common/Company/ChatBoxButton"));
    const ChatMessages = React.lazy(() => import("./Profile/ChatMessages/ChatMessages"))

    const LoginWithCert = React.lazy(() => import("./Common/LoginWithCert"));

    const footerWrapper = document.querySelectorAll(".footer");
    if (footerWrapper.length) {
        footerWrapper.forEach(i => (
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <QueryClientProvider client={queryClient}>
                        <Footer />
                    </QueryClientProvider>
                </React.Suspense>,
                i,
            )
        ))
    }

    const header = document.getElementsByClassName("headerMenu");
    if (header) {
        for (let i of header) {
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <Header
                        mode={i.getAttribute("data-mode")}
                    />
                </React.Suspense>,
                i,
            );
        }
    }

    const profileDocumentsContainer = document.getElementById("profile_documents_container");
    if (profileDocumentsContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <QueryClientProvider client={queryClient}>
                    <ProfileDocuments />
                </QueryClientProvider>
            </React.Suspense>,
            profileDocumentsContainer,
        );
    }

    const usefulLinks = document.getElementById("usefulLinks");
    if (usefulLinks) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <UsefulLinks />
            </React.Suspense>,
            usefulLinks,
        );
    }

    const mainSearchContainer = document.getElementById("main_search");
    if (mainSearchContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <MainSearch />
            </React.Suspense>,
            mainSearchContainer,
        );
    }

    const smallPromoLots = document.getElementById("smallPromoLots");
    if (smallPromoLots) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <SmallPromoLots />
            </React.Suspense>,
            smallPromoLots,
        );
    }


    const contactPopups = document.getElementsByClassName("contactPopup");

    if (contactPopups) {
        for (let contactPopup of contactPopups) {
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <ContactPopup addition={contactPopup.getAttribute('data-addition')} />
                </React.Suspense>,
                contactPopup,
            );
        }
    }

    const agentHelperPopups = document.getElementsByClassName("agentHelperPopup");

    if (agentHelperPopups) {
        for (let agentHelperPopup of agentHelperPopups) {
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <AgentHelper addition={agentHelperPopup.getAttribute('data-addition')} />
                </React.Suspense>,
                agentHelperPopup,
            );
        }
    }

    const contactForm = document.getElementsByClassName("feedback-form_wrapper");
    if (contactForm) {
        for (let i of contactForm) {
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <QueryClientProvider client={queryClient}>
                        <ContactForm />
                    </QueryClientProvider>
                </React.Suspense>,
                i,
            );
        }
    }
    //!TODO временно пока возвращаем другой компонент
    const lotpage = document.getElementById("newLotPage");
    if (lotpage) {
        ReactDOM.render(
            <AppWrapper>
                <LotPage
                    lotId={lotpage.getAttribute('data-lotId')}
                    theme={lotpage.getAttribute('data-theme')}
                />
            </AppWrapper>,
            lotpage,
        );
    }

    const personalData = document.getElementById("personalData");
    if (personalData) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Provider store={ store }>
                    <QueryClientProvider client={queryClient}>
                        <PersonalData />
                    </QueryClientProvider>
                </Provider>
            </React.Suspense>,
            personalData,
        );
    }

    // аукцион с приёмом заявок - страница просомтра лота
    const openAuctionWithApplications = document.getElementById("openAuctionWithApplications-view");
    if (openAuctionWithApplications) {
        ReactDOM.render(
            <AppWrapper>
                <OpenAuctionWithApplications
                    lotId={openAuctionWithApplications.getAttribute('data-lotId')}
                />
            </AppWrapper>,
            openAuctionWithApplications,
        );
    }

    // аукцион с приёмом заявок режим чтения - страница просомтра лота
    const lotWithApplicationReadOnly = document.getElementById("openAuctionWithApplications-readOnly");
    if (lotWithApplicationReadOnly) {
        ReactDOM.render(
            <AppWrapper>
                <OpenAuctionWithApplicationsReadOnly
                    lotId={lotWithApplicationReadOnly.getAttribute('data-lotId')}
                />
            </AppWrapper>,
            lotWithApplicationReadOnly,
        );
    }

    // открытый аукцион без ЭЦП - страница просомтра лота
    const openAuction = document.getElementById("openAuction-view");
    if (openAuction) {
        ReactDOM.render(
            <AppWrapper>
                <OpenAuction
                    lotId={openAuction.getAttribute('data-lotId')}
                />
            </AppWrapper>,
            openAuction,
        );
    }

    // открытый аукцион без ЭЦП режим чтения - страница просомтра лота
    const openAuctionReadOnly = document.getElementById("openAuction-readOnly");
    if (openAuctionReadOnly) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Provider store={store}>
                    <QueryClientProvider client={queryClient}>
                        <OpenAuctionReadOnly
                            lotId={openAuctionReadOnly.getAttribute('data-lotId')}
                        />
                    </QueryClientProvider>
                </Provider>
            </React.Suspense>,
            openAuctionReadOnly,
        );
    }

    // открытый аукцион с задатком - страница просомтра лота
    const openAuctionWithDeposit = document.getElementById("openAuctionWithDeposit-view");
    if (openAuctionWithDeposit) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Provider store={store}>
                    <QueryClientProvider client={queryClient}>
                        <OpenAuctionWithDeposit
                            lotId={openAuctionWithDeposit.getAttribute('data-lotId')}
                        />
                    </QueryClientProvider>
                </Provider>
            </React.Suspense>,
            openAuctionWithDeposit,
        );
    }

    // открытый аукцион с задатком режим чтения - страница просомтра лота    
    const openAuctionWithDepositReadOnly = document.getElementById("openAuctionWithDeposit-readOnly");
    if (openAuctionWithDepositReadOnly) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Provider store={store}>
                    <QueryClientProvider client={queryClient}>
                        <OpenAuctionWithDepositReadOnly
                            lotId={openAuctionWithDepositReadOnly.getAttribute('data-lotId')}
                        />
                    </QueryClientProvider>
                </Provider>
            </React.Suspense>,
            openAuctionWithDepositReadOnly,
        );
    }



    const eventsList = document.getElementById("eventsList");
    if (eventsList) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <EventsList />
            </React.Suspense>,
            eventsList,
        );
    }

    const promoLotsWrapper = document.getElementById("promoLotsWrapper");
    if (promoLotsWrapper) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <PromoLotsList />
            </React.Suspense>,
            promoLotsWrapper,
        );
    }

    const nearestLotsWrapper = document.getElementById("nearestLotsWrapper");
    if (nearestLotsWrapper) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <NearestLots />
            </React.Suspense>,
            nearestLotsWrapper,
        );
    }

    const pageNotifications = document.getElementById("notifications");
    if (pageNotifications) {
        ReactDOM.render(

            <React.Suspense fallback={<div className="loading show"></div>}>
                <Notifications />
            </React.Suspense>,
            pageNotifications,
        );
    }

    const pagePromotionServices = document.getElementById("promotion-services");
    if (pagePromotionServices) {
        ReactDOM.render(

            <React.Suspense fallback={<div className="loading show"></div>}>
                <PromotionServices />
            </React.Suspense>,
            pagePromotionServices,
        );
    }

    const bankDetails = document.getElementById("bankDetails");
    if (bankDetails) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <QueryClientProvider client={queryClient}>
                    <BankDetails />
                </QueryClientProvider>
            </React.Suspense>,
            bankDetails,
        );
    }

    const tariffsList = document.getElementById("tariffsList");
    if (tariffsList) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <TariffsList
                    ProjectsDictionary={tariffsList.getAttribute('data-projectsDictionary')}
                    ActiveServiceName={tariffsList.getAttribute("data-activeServiceName")}
                    ActiveOrderId={tariffsList.getAttribute("data-activeOrderId")}
                />
            </React.Suspense>,
            tariffsList,
        );
    }

    const cert = document.getElementById("cert");
    if (cert) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <QueryClientProvider client={queryClient}>
                    <Cert />
                </QueryClientProvider>
            </React.Suspense>,
            cert,
        );
    }

    const myBalance = document.getElementById("myBalance");
    if (myBalance) {
        let serv = myBalance.getAttribute("data-listServices");
        let purchServ = myBalance.getAttribute("data-purchasedServices");
        let purchLotApp = myBalance.getAttribute("data-purchasedLotApplicationPrice")
        let projectsDictionary = myBalance.getAttribute("data-projectsDictionary")
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <MyBalance
                    Balance={Number(myBalance.getAttribute("data-amount"))}
                    PurchasedLotApplicationPrices={JSON.parse(purchLotApp)}
                    ListServices={JSON.parse(serv)}
                    PurchasedServices={JSON.parse(purchServ)}
                    CompanyId={Number(myBalance.getAttribute("data-companyId"))}
                    Amount={Number(myBalance.getAttribute("data-amount"))}
                    AccountId={Number(myBalance.getAttribute("data-accountId"))}
                    ActiveServiceName={myBalance.getAttribute("data-activeServiceName")}
                    ActiveOrderId={Number(myBalance.getAttribute("data-activeOrderId"))}
                    ProjectsDictionary={JSON.parse(projectsDictionary)}
                />
            </React.Suspense>, myBalance
        );
    }

    const pageRatingLimit = document.getElementById("rating-limit");
    if (pageRatingLimit) {
        ReactDOM.render(

            <React.Suspense fallback={<div className="loading show"></div>}>
                <RatingLimit />
            </React.Suspense>,
            pageRatingLimit,
        );
    }



    const pageOperatinosHistory = document.getElementById("operations-history");
    if (pageOperatinosHistory) {
        ReactDOM.render(

            <React.Suspense fallback={<div className="loading show"></div>}>
                <OperatinosHistory />
            </React.Suspense>,
            pageOperatinosHistory,
        );
    }

    const catalogRef = document.getElementById('catalogLots');
    if (catalogRef) {
        const rawCategoryId = catalogRef.getAttribute("data-category-id");
        let categoryIds = [];

        try {
            categoryIds = JSON.parse(rawCategoryId);
        } catch {
            categoryIds = rawCategoryId.split(',').map(Number);
        }

        const date1 = moment(catalogRef.getAttribute("data-start-date"), 'YYYY-MM-DDTHH:mm:ss');
        const date2 = moment(catalogRef.getAttribute("data-end-date"), 'YYYY-MM-DDTHH:mm:ss');

        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Catalog
                    CategoryId={categoryIds}
                    CurrentPage={Number(catalogRef.getAttribute("data-current-page"))}
                    CountLotsOnPage={Number(catalogRef.getAttribute("data-count-lots-on-page"))}
                    AuctionType={Number(catalogRef.getAttribute("data-auction-type"))}
                    SalesType={Number(catalogRef.getAttribute("data-sales-type"))}
                    TimeSearch={Number(catalogRef.getAttribute("data-time-search"))}
                    StartDate={date1.isValid() ? date1.format('YYYY-MM-DDTHH:mm:ss') : null}
                    EndDate={date2.isValid() ? date2.format('YYYY-MM-DDTHH:mm:ss') : null}
                    StartPrice={Number(catalogRef.getAttribute("data-start-price"))}
                    EndPrice={Number(catalogRef.getAttribute("data-end-price"))}
                    TextSearch={catalogRef.getAttribute("data-text-search")}
                    mitraTheme={catalogRef.getAttribute("data-theme")}
                />
            </React.Suspense>,
            catalogRef,
        );
    }


    const boutique = document.getElementById('boutiqueRealty');
    if (boutique) {
        console.log(boutique.getAttribute("data-category-id"));
        var date1 = moment(boutique.getAttribute("data-start-date"), 'YYYY-MM-DDTHH:mm:ss');
        var date2 = moment(boutique.getAttribute("data-end-date"), 'YYYY-MM-DDTHH:mm:ss');
        console.log(date1, date2);
        ReactDOM.render(

            <React.Suspense fallback={<div className="loading show"></div>}>
                <Boutique CategoryId={Number(boutique.getAttribute("data-category-id"))}
                    CurrentPage={Number(boutique.getAttribute("data-current-page"))}
                    CountLotsOnPage={Number(boutique.getAttribute("data-count-lots-on-page"))}
                    AuctionType={Number(boutique.getAttribute("data-auction-type"))}
                    SalesType={Number(boutique.getAttribute("data-sales-type"))}
                    TimeSearch={Number(boutique.getAttribute("data-time-search"))}
                    StartDate={date1.isValid() ? date1.format('YYYY-MM-DDTHH:mm:ss') : NaN}
                    EndDate={date2.isValid() ? date1.format('YYYY-MM-DDTHH:mm:ss') : NaN}
                    StartPrice={Number(boutique.getAttribute("data-start-price"))}
                    EndPrice={Number(boutique.getAttribute("data-end-price"))}
                />
            </React.Suspense>,
            boutique,
        );
    }




    const MessageToBuyersContainer = document.getElementById("message-to-buyers");
    if (MessageToBuyersContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <MessageToBuyers />
            </React.Suspense>,
            MessageToBuyersContainer,
        );
    }

    const chatBoxContainer = document.getElementById("chat-box-container");
    if (chatBoxContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show" />}>
                <ChatBoxButton
                    currentAccountId={chatBoxContainer.getAttribute("data-current-user-id")}
                    lotId={chatBoxContainer.getAttribute("data-lot-id")}
                    sellerName={chatBoxContainer.getAttribute("data-seller-name")}
                    sellerAvatar={chatBoxContainer.getAttribute("data-seller-avatar")} />
            </React.Suspense>,
            chatBoxContainer,
        );
    }

    const chatMessagesContainer = document.getElementById("chat_messages");
    if (chatMessagesContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <ChatMessages lotId={chatMessagesContainer.getAttribute("data-lot-id")}
                    currentAccountId={chatMessagesContainer.getAttribute("data-current-user-id")}
                    // sellerName={chatMessagesContainer.getAttribute("data-seller-name")}
                    sellerAvatar={chatMessagesContainer.getAttribute("data-seller-avatar")} />
            </React.Suspense>,
            chatMessagesContainer,
        );
    }

    const lotEditorContainer = document.getElementById("lot_editor");
    if (lotEditorContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Provider store={store}>
                    <LotsEditor
                        lotId={Number(lotEditorContainer.getAttribute("data-lot-id"))}
                        validate={lotEditorContainer.getAttribute("data-validate") == "true"}
                        isEdit={lotEditorContainer.getAttribute("data-is-edit") == "true"}
                        ListAvailableAuctions={[1, 32]}

                    />
                </Provider>
            </React.Suspense>,
            lotEditorContainer
        );
    }

    const loginWithCert = document.getElementById("login_with_cert_container");
    if (loginWithCert) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <LoginWithCert />
            </React.Suspense>,
            loginWithCert,
        );
    }

    let target = document.querySelector('header');
    const config = {
        childList: true,
        subtree: true
    };

    const callback = function () {
        const watermarkContainer = document.getElementById('watermark-id')
        if (watermarkContainer) {
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <Watermarks />
                </React.Suspense>,
                watermarkContainer,
            );
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(target, config);


    const myDeposits = document.getElementById("myDeposits");
    if (myDeposits) {
        let serv = myDeposits.getAttribute("data-listServices");
        let purchServ = myDeposits.getAttribute("data-purchasedServices");
        let purchLotApp = myDeposits.getAttribute("data-purchasedLotApplicationPrice")
        let projectsDictionary = myDeposits.getAttribute("data-projectsDictionary")
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <MyDeposits
                    Balance={Number(myDeposits.getAttribute("data-amount"))}
                    PurchasedLotApplicationPrices={JSON.parse(purchLotApp)}
                    ListServices={JSON.parse(serv)}
                    PurchasedServices={JSON.parse(purchServ)}
                    CompanyId={Number(myDeposits.getAttribute("data-companyId"))}
                    Amount={Number(myDeposits.getAttribute("data-amount"))}
                    AccountId={Number(myDeposits.getAttribute("data-accountId"))}
                    ActiveServiceName={myDeposits.getAttribute("data-activeServiceName")}
                    ActiveOrderId={Number(myDeposits.getAttribute("data-activeOrderId"))}
                    ProjectsDictionary={JSON.parse(projectsDictionary)}
                />
            </React.Suspense>,
            myDeposits,
        );
    }

    const rateContainer = document.getElementById("rate_container");
    if (rateContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Rate />
            </React.Suspense>,
            rateContainer,
        );
    }

    const appealContainer = document.getElementById("appeal_container");
    if (appealContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Appeal />
            </React.Suspense>,
            appealContainer,
        );
    }


    //const lotDocumentContainer = document.getElementById(
    //    "lot_document_container",
    //);
    //if (lotDocumentContainer) {
    //    ReactDOM.render(
    //        <React.Suspense fallback={<div className="loading show"></div>}>
    //            <LotDocument lotId={Number(lotDocumentContainer.getAttribute("lotId"))} />
    //        </React.Suspense>,
    //        lotDocumentContainer,
    //    );
    //}

    const lotDocumentsContainer = document.getElementById(
        "lot_documents_container",
    );
    if (lotDocumentsContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <DocumentsList loadUrl={"/TradeLotActionsApi/GetLotDocuments"} refresh={true} lotId={Number(lotDocumentsContainer.getAttribute("lotId"))} />
            </React.Suspense>,
            lotDocumentsContainer,
        );
    }

    const lotWinnerProtocolContainer = document.getElementById(
        "lot_winner_protocol_container",
    );
    if (lotWinnerProtocolContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <LotWinnerProtocol lotId={Number(lotWinnerProtocolContainer.getAttribute("lotId"))} />
            </React.Suspense>,
            lotWinnerProtocolContainer,
        );
    }

    const vacationContainer = document.getElementById("vacation_container");
    if (vacationContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <VacationDetailsEditor />
            </React.Suspense>,
            vacationContainer,
        );
    }

    const deliveryAdressContainer = document.getElementById(
        "deliveri_adress_container",
    );
    if (deliveryAdressContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <DeliveryAdressDetailsEditor />
            </React.Suspense>,
            deliveryAdressContainer,
        );
    }

    const blackListSellersContainer = document.getElementById(
        "black_list_sellers_container",
    );
    if (blackListSellersContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <BlackListSellersDetailsEditor />
            </React.Suspense>,
            blackListSellersContainer,
        );
    }
    const blackListBuyersContainer = document.getElementById(
        "black_list_buyers_container",
    );
    if (blackListBuyersContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <BlackListBuyersDetailsEditor />
            </React.Suspense>,
            blackListBuyersContainer,
        );
    }
    const locationlotContainer = document.getElementById("location_lot_container");
    if (locationlotContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <LocationLotDetailsEditor />
            </React.Suspense>,
            locationlotContainer,
        );
    }
    const standartDescriptionLotContainer = document.getElementById(
        "description_lot_container",
    );
    if (standartDescriptionLotContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <StandartDescriptionLotEditor />
            </React.Suspense>,
            standartDescriptionLotContainer,
        );
    }

    const balanceContainer = document.getElementById("balans_container");
    if (balanceContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <BalanceEditor />
            </React.Suspense>,
            balanceContainer,
        );
    }

    const documentsListContainer = document.getElementById("documents_list");
    if (documentsListContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <DocumentsList
                    lotId={Number(documentsListContainer.getAttribute('data-lotId'))}
                    loadUrl={documentsListContainer.getAttribute("data-load-url")}
                    refresh={false}
                />
            </React.Suspense>,
            documentsListContainer,
        );
    }

    const myActivityContainer = document.getElementById("my_activity");
    if (myActivityContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Provider store={store}>
                    <BrowserRouter>
                        <MyActivity2 />
                    </BrowserRouter>
                </Provider>
            </React.Suspense>,
            myActivityContainer,
        );
    }

    const myActivity = document.getElementById("my_activity_new");
    if (myActivity) {
        var menuItem = myActivity.getAttribute('data-item');
        console.log('menuItem=', menuItem);
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Provider store={store}>
                    <QueryClientProvider client={queryClient}>
                        <MyActivityClass LotId={myActivity.getAttribute('data-lot-id')}
                            LotName={myActivity.getAttribute('data-lot-name')}
                            LotStatus={myActivity.getAttribute('data-status')}
                            Item={menuItem} />
                    </QueryClientProvider>
                </Provider>

            </React.Suspense>,
            myActivity,
        );
    }

    const toggleLotIsFavoriteContainers =
        document.getElementsByClassName("favourites-toggle");

    if (toggleLotIsFavoriteContainers && toggleLotIsFavoriteContainers.length > 0) {
        [...toggleLotIsFavoriteContainers].map((container) =>
            ReactDOM.render(
                <React.Suspense fallback={<div></div>}>
                    <ToggleLotIsFavorite
                        lotId={Number(container.getAttribute("data-lotId"))}
                        curUserFavorite={
                            container.getAttribute("data-curUserFavorite").toLowerCase() ==
                            "true"
                        }
                        userLoggedIn={
                            container.getAttribute("data-userLoggedIn").toLowerCase() == "true"
                        }
                        showText={
                            container.getAttribute("data-showText").toLowerCase() == "true"
                        }
                        type={container.getAttribute("data-fav-type")}
                    />
                </React.Suspense>,
                container,
            ),
        );
    }

    const popupBuyNowContainer = document.getElementById("popupBuyNow");
    if (popupBuyNowContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <PopupBuyNow
                    lotId={popupBuyNowContainer.getAttribute("data-lotId")}
                    isTradeEnd={popupBuyNowContainer.getAttribute("data-isTradeEnd")}
                    mithraTheme={popupBuyNowContainer.getAttribute("data-mithraTheme")}
                    shippingMethod={popupBuyNowContainer.getAttribute("data-shippingMethod")}
                />
            </React.Suspense>,
            popupBuyNowContainer
        );
    }

    const newsList = document.getElementById("newsList")
    if (newsList) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <QueryClientProvider client={queryClient}>
                    <NewsList
                        Count={newsList.getAttribute("data-count")}
                    />
                </QueryClientProvider>
            </React.Suspense>,
            newsList
        );
    }

    const temp = document.querySelector(".helpBot");


    if (temp) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <Provider store={store}>
                    <Store />
                </Provider>
            </React.Suspense>,
            temp
        );
    }

    //const applicationDetails = document.getElementById('lotApplicationBlock');
    //if (applicationDetails) {
    //	ReactDOM.render(
    //		<ApplicationDetails lotId={applicationDetails.getAttribute("data-lotId")} />,
    //		applicationDetails);
    //}

    //const acceptanceDetails = document.getElementById('lotAcceptanceBlock');
    //if (acceptanceDetails) {
    //	ReactDOM.render(
    //		<ApplicationAcceptance lotId={acceptanceDetails.getAttribute("data-lotId")} />,
    //		acceptanceDetails);
    //}
}

console.log("Rosim branch");